import Vue from 'vue'
import Vuex from 'vuex'
import applicants from './modules/applicants'
import infoSessions from './modules/infoSessions'
import createPersistedState from "vuex-persistedstate";
import applicantProfile from "./modules/applicantProfile";
import filters from "./modules/filters";

Vue.use(Vuex)
const persistedStateOptions={
    paths:[
        'applicantProfile.applicant',
        'applicants.applicantEmail'

    ]
}

export default new Vuex.Store({
    // plugins: [createPersistedState({
    //     storage: window.localStorage,
    //     reducer: state => ({
    //         applicant: applicantProfile.state.applicant,
    //         applicantEmail: applicants.state.applicantEmail,
    //         allApplicants: state.allApplicants
    //     })
    // })],
    modules: {
        applicants,
        applicantProfile,
        infoSessions,
        filters,
    },
    plugins:[createPersistedState(persistedStateOptions)]
})